module.exports = __webpack_public_path__ + "static/logo-fusionbase-891896602da274571c611b68d58f69e0.svg";